import type { OpportunitySkillDto } from '../../opportunity/dto'
import type { RawValidResponse } from '../../goodstack'

import type { QueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'

export const getVolunteeringSkills: QueryFn<[string], OpportunitySkillDto[]> = async client => {
  const res = await client.get<RawValidResponse<OpportunitySkillDto[]>>(`v1/volunteering-skills`, {
    withCredentials: true
  })

  return res.data.data
}
